module.exports = __webpack_public_path__ + "static/media/tripleedge.fd58dacc.jpeg";